export const statusMapping = {
    1: "New",
    2: "Quotation",
    3: "Signed",
    4: "Completed",
    5: "Remark",
    6: "Special",
    7: "InReview",
    8: "Toewijzen",
    9: "Verlopen – concurrentie",
    10: "Verlopen – foutief ingeschreven",
    11: "Verlopen – niet bekend",
    12: "Verlopen – prijs",
    13: "Verlopen – opdracht via andere offerte",
    14: "Onderhanden",
    15: "Geen offerte uitgebracht",
    16: "Verloren offerte",
    17: "Afgerond richting planning"
};
export const statusBgColor = {
    1: "#E9ECEF",
    2: "#EBF7FD",
    3: "#DFF1E3",
    4: "#F4DFF4",
    5: "#FFFAEB",
    6: "#FBE9DA",
    7: "#dfd8e6",
    8: "#ebf7e9",
    9: "#edd9d8",
    10: "#edd9d8",
    11: "#edd9d8",
    12: "#edd9d8",
    13: "#edd9d8",
    14: "#E3F2FD", // Light blue for "Onderhanden"
    15: "#FFF3E0", // Light orange for "Geen offerte uitgebracht"
    16: "#FFEBEE", // Light red for "Verloren offerte"
    17: "#E2E6F9" // Light indigo for "Afgerond richting planning"
};
export const statusTextColor = {
    1: "#495057",
    2: "#005892",
    3: "#2AA241",
    4: "#B425B7",
    5: "#FFBF00",
    6: "#E26D12",
    7: "#E52521",
    8: "#2E7D32", // Green for "Toewijzen" 
    9: "#B71C1C", // Dark red for deprecated statuses
    10: "#B71C1C",
    11: "#B71C1C",
    12: "#B71C1C",
    13: "#B71C1C",
    14: "#1976D2", // Blue for "Onderhanden"
    15: "#F57C00", // Orange for "Geen offerte uitgebracht"
    16: "#D32F2F", // Red for "Verloren offerte"
    17: "#3F4EAE" // Indigo for "Afgerond richting planning"
};
export const resultTextColor = {
    1: "#2AA241",
    2: "#E52521"
};
export const resultBackgroundColor = {
    1: "#DFF1E3",
    2: "#FBDFDE"
};
export const objectStatusMapping = {
    1: "New",
    2: "Special",
    3: "Quotation",
    4: "Signed",
    5: "Remark",
};
export const objectStatusBgColor = {
    1: "#E9ECEF",
    2: "#FBE9DA",
    3: "#EBF7FD",
    4: "#DFF1E3",
    5: "#FFFAEB"
};
export const objectStatusTextColor = {
    1: "#495057",
    2: "#E26D12",
    3: "#005892",
    4: "#2AA241",
    5: "#FFBF00"
};
// ============================================================================================================
// NEW DYNAMIC OBJECT STATUS COLOR MAPPING
// ============================================================================================================
/**
 * Color mapping for new dynamic object statuses (by status name)
 * Maps system status names to their respective background and text colors
 * This supports the new hierarchical status system (Level 1, 2, 3)
 */
export const dynamicObjectStatusColors = {
    // System statuses (mapped from old enum values for backward compatibility)
    "Nieuw": {
        bgColor: "#E9ECEF", // Light gray
        textColor: "#495057" // Dark gray
    },
    "New": {
        bgColor: "#E9ECEF",
        textColor: "#495057"
    },
    "Special": {
        bgColor: "#FBE9DA", // Light orange
        textColor: "#E26D12" // Orange
    },
    "Offerte": {
        bgColor: "#EBF7FD", // Light blue
        textColor: "#005892" // Blue
    },
    "Quotation": {
        bgColor: "#EBF7FD",
        textColor: "#005892"
    },
    "Ondertekend": {
        bgColor: "#DFF1E3", // Light green
        textColor: "#2AA241" // Green
    },
    "Signed": {
        bgColor: "#DFF1E3",
        textColor: "#2AA241"
    },
    "Opmerking": {
        bgColor: "#FFFAEB", // Light yellow
        textColor: "#FFBF00" // Yellow/Gold
    },
    "Remark": {
        bgColor: "#FFFAEB",
        textColor: "#FFBF00"
    },
    "Completed": {
        bgColor: "#F4DFF4",
        textColor: "#B425B7"
    },
    // Same purple as "Completed" - this is a label-only rename of the same status
    // (previously named "Voltooid"), not a new one, so it keeps the same color.
    "Compleet": {
        bgColor: "#F4DFF4",
        textColor: "#B425B7"
    },
    "Afgerond richting planning": {
        bgColor: "#E2E6F9", // Light indigo
        textColor: "#3F4EAE" // Indigo
    },
};
/**
 * Default colors for statuses that don't have specific mapping
 */
export const defaultObjectStatusColors = {
    bgColor: "#E9ECEF", // Light neutral gray (same as "New")
    textColor: "#495057" // Dark gray text
};
/**
 * Get background and text colors for a given object status name
 * @param statusName - The name of the status (from Level 1, 2, or 3)
 * @returns Object containing bgColor and textColor
 *
 * Usage:
 * const colors = getObjectStatusColors(row.statusLevel1Name);
 * <Box bgcolor={colors.bgColor}>
 *   <Typography color={colors.textColor}>{statusName}</Typography>
 * </Box>
 */
export const getObjectStatusColors = (statusName) => {
    if (!statusName) {
        return defaultObjectStatusColors;
    }
    // Check if we have a specific mapping for this status name
    const colors = dynamicObjectStatusColors[statusName];
    if (colors) {
        return colors;
    }
    // Return default colors for unmapped statuses
    return defaultObjectStatusColors;
};
